import React from "react";
import { Spin } from "antd";

import { Link } from "react-router-dom";
import { ArrowRightOutlined } from "@ant-design/icons";

interface props {}

const QuestionaireCompleted: React.FC<props> = () => {
  return (
    <div className="completed-message">
      <Spin size="large" />
      <h2 style={{ maxWidth: "500px" }}>
        We are personalizing your skincare routine... This may take upto 30
        seconds.
      </h2>
      {/* <p>
        Now its time for you to take some rest. A skincare expert will handcraft
        it from here. Be ready to visit your personal skincare space in 2
        business days or less. We will email you once it's ready.
      </p> */}
      {/* <p>
        Submitting...
      </p> */}

      {/* <Link to="/processing" className="btn-secondary-link-icon">
        Go Back To Home
        <ArrowRightOutlined />
      </Link> */}

      {/* <Link
        to="/store"
        className="btn-secondary-link-icon store-link"
        target={"_blank"}
      >
        Store
        <ArrowRightOutlined />
      </Link> */}
    </div>
  );
};

export default QuestionaireCompleted;
